<template>
  <!-- 栏目中间页 -->
  <div>
    <!-- lvHeader -->
    <lv-header />
    <!-- lvNav -->
    <lv-nav  class="na" />

    <router-view></router-view>

    <!-- 底部footer -->
    <lv-footer />
    
  </div>
</template>

<script>
import lvHeader from "components/content/lvHeader/lvHeader";
import lvNav from "components/content/lvNav/lvNav";
import lvFooter from "components/content/lvFooter/lvFooter";


export default {
  name: "midpage",

  components: {
    // 公
    lvHeader,
    lvNav,
    lvFooter,


  },
};
</script>

<style lang="scss" scope>
.na{
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
}
</style>